export class WebhookV1StandardPayloadCreditsUsage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadCreditsUsageTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadCreditsUsageArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadCreditsUsage.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadCreditsUsageTypeEnum;
(function (WebhookV1StandardPayloadCreditsUsageTypeEnum) {
    WebhookV1StandardPayloadCreditsUsageTypeEnum["_75"] = "CREDITS_USAGE_THRESHOLD_75";
    WebhookV1StandardPayloadCreditsUsageTypeEnum["_90"] = "CREDITS_USAGE_THRESHOLD_90";
    WebhookV1StandardPayloadCreditsUsageTypeEnum["_95"] = "CREDITS_USAGE_THRESHOLD_95";
})(WebhookV1StandardPayloadCreditsUsageTypeEnum || (WebhookV1StandardPayloadCreditsUsageTypeEnum = {}));
